import { Injectable, EventEmitter, Inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpClient,
  HttpBackend,
} from '@angular/common/http';

import { SessionService } from './session.service';
import { BehaviorSubject, interval, Observable, throwError } from 'rxjs';
import { environment } from '@tech-environments/environment';
import { map, catchError } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { MatDialog } from '@angular/material/dialog';
import { AppConfig } from '@tech-utils/app-config.service';
import { DOCUMENT } from '@angular/common';
/*
import { CurrencyInterface } from '@tech-interfaces/currency.interface';
import { ClientDataApiRest } from '@tech-models/client-data-apirest.model';
*/
import {
  CommonService as sdkService,
  ClientDataApiRest,
  ChatService,
  ClientData,
} from '@techrules/portallib';
import { TechDialogsService } from '../../shared/tech-dialogs.service';
import { LoadingScreenDialogComponent } from '../../areas/ui/loading-screen-dialog/loading-screen-dialog.component';
import { LoadingcustodianComponent } from '../../areas/ui/loadingcustodian/loadingcustodian.component';

@Injectable()
export class CommonService {
  private clientData: ClientData;
  public colorGrl = AppConfig.cssVars.colors.principalColors;
  // public colorGrl = [
  //   '#1FF4FF', //$color-02: Azul Claro Portal Cliente
  //   '#013475', //$color-01: Azul Oscuro Portal Cliente
  //   '#171b2c', //$color-03: Azul muy Oscuro Portal Cliente
  //   '#a7b1c2', //$color-04: Gris Portal Cliente
  //   '#0096ff', //$color-05: Azul Claro 2 Portal Cliente
  // ];
  public colorGrafic = AppConfig.cssVars.colors.colorGraphic;
  public colorGrafic2 = AppConfig.cssVars.colors.colorGraphic2;
  public colorGraficTotal = AppConfig.cssVars.colors.colorGraphic.concat(
    AppConfig.cssVars.colors.colorGraphic2,
  );
  public panelClassGeneral = [
    'col-xs-12',
    'col-sm-8',
    'col-md-6',
    'col-lg-5',
    'mw-500',
  ];
  public menuOpen = false;
  public isMovilSource = new BehaviorSubject<boolean>(true);
  public isMovil$ = this.isMovilSource.asObservable();
  public AppSetting: any;
  public portfolioCodeSource = new BehaviorSubject<string>({} as any);
  public portfolioCode$ = this.portfolioCodeSource.asObservable();
  loading$ = new EventEmitter<boolean>();
  public loadingThinking$ = new EventEmitter<boolean>();
  public noPortfolios$ = new EventEmitter<boolean>();
  public isProductiveSource = new BehaviorSubject<boolean>(false);
  public isProductive$ = this.isProductiveSource.asObservable();
  public stepOKSource = new BehaviorSubject<boolean>(false);
  public stepOK$ = this.stepOKSource.asObservable();
  public showMenuSource = new BehaviorSubject<boolean>(true);
  public showMenu$ = this.showMenuSource.asObservable();
  public clientDataSource = new BehaviorSubject<ClientData>({} as any);
  public clientData$ = this.clientDataSource.asObservable();
  public clientDataInitialSource = new BehaviorSubject<ClientDataApiRest>(
    {} as any,
  );
  public clientDataInitial$ = this.clientDataInitialSource.asObservable();
  public chatListenerSource = new BehaviorSubject<string>({} as any);
  public chatListener$ = this.chatListenerSource.asObservable();
  public notificationUpNavSource = new BehaviorSubject<number>(0);
  public notificationUpNav$ = this.notificationUpNavSource.asObservable();
  public chartsConfig = AppConfig.cssVars.charts;
  public forcedLanguageSource = new BehaviorSubject<boolean>(false);
  public forcedLanguage$ = this.forcedLanguageSource.asObservable();
  public deviceidSource = new BehaviorSubject<string>({} as any);
  public deviceid$ = this.deviceidSource.asObservable();
  public verificationIdSource = new BehaviorSubject<string>({} as any);
  public verificationId$ = this.verificationIdSource.asObservable();

  private token01: string = '';
  private token02: string = '';

  private http: HttpClient;

  constructor(
    private sdkSvc: sdkService,
    private httpBackend: HttpBackend,
    private titleService: Title,
    public dialog: MatDialog,
    private session: SessionService,
    private router: Router,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    private chatSvc: ChatService,
    @Inject(DOCUMENT) private document: any,
  ) {
    this.http = new HttpClient(this.httpBackend);

    // this.loading$.subscribe((val: boolean) => {
    //   if (val) {
    //     this.viewLoadingModal();
    //   } else {
    //     this.closeLoadingModal();
    //   }
    // });
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  errorManager(service: string, err: HttpErrorResponse) {
    if (!this.dialogService.displayedModal) {
      if (err.error.Code == 'Invalid_Tower30SessionToken') {
        let text1 =
          this.translate.instant('k001706') == 'k001706'
            ? 'Session expired'
            : this.translate.instant('k001706');
        let text2 =
          this.translate.instant('k001704') == 'k001704'
            ? 'Session expired or authentication error. Please log in again.'
            : this.translate.instant('k001704');
        this.dialogService.openModalDialog('', text1, text2, ''); //Token: Session caducada Token: Sesión caducada. Por favor vuelva a logearse
        this.dialogService.displayedModal = true;
        this.router.navigate(['/login']);
      } else if (
        err.error.ExceptionMessage == 'Token is null or Empty.' ||
        err.error.ExceptionMessage ==
        'Padding is invalid and cannot be removed.'
      ) {
        this.dialogService.displayedModal = true;
        this.router.navigate(['/login']);
      } else if (err.error.Code == 'Invalid_UsernamePassword') {
        this.dialogService.openModalDialog(
          '',
          this.translate.instant('k002788'),
          this.translate.instant('k002789'),
          //Token: Email o contraseña incorrecta
          //Token: Vuelve a intentarlo o selecciona "Recuperar contraseña”.
          '',
        );
      } else if (err.error.Code == 'Login_Attempts') {
        this.dialogService.openModalDialog(
          '',
          this.translate.instant('k002788'), //Token: Email o contraseña incorrecta
          err.error.Message,
          '',
        );
      } else {
        this.dialogService.displayedModal = true;
        this.dialogService.openErrorDialog(err);
      }
    }
  }

  getClientData(): Observable<ClientData> {
    return this.sdkSvc.getClientData().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  getCustodianClient(): Observable<ClientData> {
    return this.sdkSvc.apiCustodianClient().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  goLogout() {
    this.sdkSvc.logOut().subscribe((res) => {
      if (res.status) {
        this.cleanupEvaChat();
        this.session.sessionToken = '';
        this.session.portfolioCode = '';
        localStorage.removeItem('SessionClientToken');
        localStorage.removeItem('ClientCode');
        localStorage.removeItem('ClientId');

        // The Eva (Aivo) SDK does not expose an official teardown API: once its
        // core script runs it keeps its own timers/websocket alive in the page,
        // so removing DOM nodes alone is not reliable. Force a full page reload
        // after navigating to /login so the whole script runtime is discarded.
        this.router.navigate(['/login']).then(() => {
          window.location.reload();
        });
      } else {
        this.dialogService.openErrorDialog(res);
      }
    });
  }

  cleanupEvaChat(): void {
    const coreScript = this.document.getElementById('_agentCoreScript');
    if (coreScript && coreScript.parentNode) {
      coreScript.parentNode.removeChild(coreScript);
    }

    if (this.document && this.document.body) {
      this.document.body.classList.remove('AgentBot', 'agentbot');
    }

    const nodes = this.document.querySelectorAll(
      'iframe[src*="agentbot.net"], iframe[src*="aivo"], .agentbot, .AgentBot, [id*="agentbot"]'
    );

    nodes.forEach((node: any) => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    try {
      delete (window as any).$aivo;
    } catch {
      (window as any).$aivo = undefined;
    }

    (window as any).__aivoBootstrapped = false;
  }

  colapseMenu() {
    this.menuOpen ? (this.menuOpen = false) : (this.menuOpen = true);
  }

  getAppSetting() {
    return this.http.get<any>(environment.appSetting);
  }

  getBaseCurrency(language: string) {
    switch (language) {
      case 'es-ES':
        return 'EUR';
      case 'en-US':
        return 'USD';
      case 'en-GR':
        return 'GBP';
      case 'es-CL':
        return 'CLP';
      case 'es-MX':
        return 'MXN';
      default:
        return 'GBP';
    }
  }

  automaticLogging(code: string, token: string): Observable<any> {
    return this.sdkSvc.automaticLogging(code, token).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err);
        this.router.navigate(['/login']);
        return throwError(err);
      }),
    );
  }

  getJSON(name: string): Observable<any> {
    let language = localStorage.getItem('Language');
    return this.http
      .get<any>('./assets/json/' + name + '_' + language + '.json')
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.dialogService.openErrorDialog(err); //Token: Error en
          return throwError(err);
        }),
      );
  }

  getJSONnoLanguage(name: string): Observable<any> {
    return this.http.get<any>('./assets/json/' + name + '.json').pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err); //Token: Error en
        return throwError(err);
      }),
    );
  }

  jumpTo(section: string) {
    setTimeout(() => {
      if (section != null && section != undefined && section != '')
        document.getElementById(section).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start',
        });
    }, 1000);
  }
  
  // Código para el nuevo screen y no se vea afectado por las demas funciones del anterior...
  // hace referencia al nuevo dialog que es el screen completo...
  private dialogRef;

  viewLoadingModal() {
    this.dialogRef = this.dialog.open(LoadingScreenDialogComponent, {
      disableClose: true,
      panelClass: 'loading-screen-dialog',
      backdropClass: 'loading-screen-backdrop',
    });
  }

  viewLoadingModalCustodian() {
    this.dialogRef = this.dialog.open(LoadingcustodianComponent, {
      disableClose: true,
      panelClass: 'loadingCustodian-screen-dialog',
      backdropClass: 'loadingCustodian-screen-backdrop',
    });
  }

  closeLoadingModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  //Funcion para mostrar el componente loading-screen  desde cualquier lado

  isloading() {
    this.loading$.emit(true);
  }

  //Funcion para ocultar el componente loading-screen  desde cualquier lado
  isnotloading() {
    this.loading$.emit(false);
  }

   /**
   * Initialize timer to check new chat messages
   * @param intervalTime
   * @returns
   */
  startUpdateCheckChatInterval(intervalTime: number): Observable<any> {
    return interval(intervalTime);
  }
  
  //Servicio para optener un identificador unico sobre el dispositivo 
  //del que esta utilizando parqa navergar en lel portal cliente.
  //este id es necesario para el login y la activacion en 2 factores
  public getDeviceId(): number {
    const navigatorInfo = [
      navigator.userAgent,
      navigator.language,
      screen.width,
      screen.height,
      screen.colorDepth,
      navigator.hardwareConcurrency,
      window.devicePixelRatio,
      window.navigator.maxTouchPoints,
    ];

    // Comprobación de soporte de audio y video
    const audioSupport = typeof AudioContext !== 'undefined' ? 1 : 0;
    const videoSupport = !!document.createElement('video').canPlayType ? 1 : 0;

    // Hora de conexión del usuario
    const date = new Date();
    const timezoneOffset = date.getTimezoneOffset();

    // Añadimos estos valores a la lista
    const identifierString = [
      ...navigatorInfo,
      audioSupport,
      videoSupport,
      timezoneOffset
    ].join('');

    // Función hash para crear un entero basado en la cadena resultante
    let hash = 0;
    for (let i = 0; i < identifierString.length; i++) {
      const char = identifierString.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convierte el hash a un entero de 32 bits
    }

    return Math.abs(hash); // Retorna un número entero positivo
  }
}
